import { RenderInput } from 'utils/RenderInput'

import { InputsTable, InputsTableProps } from './index'

export interface IInputsTableWithNoApplyData<T> {
  rows: T[]
  doNotApply: boolean
}

export const InputsTableWithNoApply = (
  props: InputsTableProps & {
    data: IInputsTableWithNoApplyData<Record<string, any>>
    onUpdate: (data: IInputsTableWithNoApplyData<Record<string, any>>) => void
  },
) => {
  return (
    <InputsTable
      {...props}
      rows={props.data?.rows ?? []}
      onUpdate={(rows: Record<string, any>[]) =>
        props.onUpdate({
          ...props.data,
          rows,
        }) as any
      }
      additionalElements={{
        title: (
          <>
            <div>
              <RenderInput
                input={{
                  inputType: 'checkbox',
                  title: 'Do not apply',
                  value: props.data.doNotApply,
                  disabled: props.readOnly,
                }}
                Key="do not apply"
                onChange={(key: string, v: boolean) => !props.readOnly && props.onUpdate({ ...props.data, doNotApply: v })}
              />
              {props.additionalElements?.title || <></>}
            </div>
          </>
        ),
      }}
    />
  )
}
